<template>
  <div class="companyProfile">
    <div class="companyxian">
      <div class="wrapW">
        <div class="left">
          <img :src="list.img"><br>
          <div class="companyProfilexian"></div>
          <div class="Tdescribe">{{list.slaveTitle}}</div>
        </div>
        <div class="right">
          <div v-html="list.desc"></div>
          <div class="button">进一步了解<span class="iconfont icon--_jiantou"></span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'companyProfile',
  data () {
    return {
      list: [],
      slaveTitle: '',
      slaveTitleX: ''
    }
  },
  mounted () {
    this.getCompany()
  },
  methods: {
    getCompany () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getCompany', {
      }).then(
        function (res) {
          res = res.data.data
          that.list = res
          that.slaveTitle = res.slaveTitle.substr(1)
          that.slaveTitleX = res.slaveTitle.substr(0,1)
        }
      ).catch(error => console.log(error))
    }
  }
}
</script>

<style lang="stylus" scoped>
.companyProfile
  position relative
  padding .58rem 0
  background-image url('~@/assets/img/community.png')
  background-size 100%
  background-repeat no-repeat
.companyxian
  width 12.4rem
  padding .2rem
  border 1px solid #fff
  margin 0 auto
  margin-top 2.6rem
.wrapW
  text-align center
  background #fff
  display flex
  align-items center
  .left
    text-align center
    flex 1
    img
      width auto
      margin-bottom .21rem
    .companyProfilexian
      width .5rem
      height .02rem
      margin 0 auto
      background #D22016
      margin-bottom .24rem
  .right
    max-width 6.8rem
    margin-right .51rem
    position relative
    padding-bottom 1rem
    >>>p
      font-size .16rem
      color #666666
      line-height .3rem
      margin-top .42rem
      text-align left
      text-indent 2em
    .button
      width 1.2rem
      margin 0 auto
      color #666666
      font-size .16rem
      border-bottom 1px solid #666666
      margin-top .4rem
      line-height .4rem
      font-weight 400
      position absolute
      right 0
    .button:hover
      color #D22016
      border-bottom 1px solid #D22016
</style>



// WEBPACK FOOTER //
// src/pages/index/components/companyProfile.vue